export const en = {
  appName: 'TrueAlpha',
  github: 'GitHub',
  privacyShort: 'Local only',
  privacyTitle: 'Your files stay on this device',
  privacyBody:
    'TrueAlpha analyzes images in browser memory. It does not upload files or call a remote analysis service.',
  language: 'Language',
  languageEnglish: 'EN',
  languageChinese: '简体中文',
  switchToChinese: 'Switch to Simplified Chinese',
  switchToEnglish: 'Switch to English',
  theme: 'Theme',
  lightTheme: 'Use light theme',
  darkTheme: 'Use dark theme',
  title: 'Is your PNG truly transparent?',
  subtitle: 'Inspect alpha pixels without uploading your files.',
  addFiles: 'Add PNG files',
  chooseFiles: 'Choose PNG files',
  dropTitle: 'Drop PNG files here',
  dropBody: 'or choose files from your device',
  dropHint: 'PNG only. Up to 25 MB each and 100 files per batch.',
  fileInputLabel: 'Choose one or more PNG files',
  validationInvalidType: '{name} is not a PNG file.',
  validationTooLarge: '{name} exceeds the 25 MB limit.',
  validationDuplicate: '{name} is already in this batch.',
  validationBatchLimit: 'Only {count} more files can be added. The batch limit is 100.',
  validationNothingAdded: 'No files were added.',
  addedFiles: 'Added {count} file(s) for local analysis.',
  dismissed: 'Dismiss message',
  notifications: 'Notifications',
  primaryNavigation: 'Primary navigation',
  reportExport: 'Report export',
  batchActions: 'Batch actions',
  batchSummary: 'Batch summary',
  summaryTotal: 'Total',
  summaryAnalyzed: 'Analyzed',
  summaryTransparent: 'Real alpha',
  summaryOpaque: 'Opaque',
  summarySuspected: 'Suspected',
  summaryErrors: 'Errors',
  summaryInProgress: 'In progress',
  results: 'Results',
  resultCount: '{count} result(s)',
  searchLabel: 'Search files',
  searchPlaceholder: 'Search by file name',
  filterLabel: 'Filter by status',
  filterAll: 'All statuses',
  filterReady: 'Analyzed',
  filterTransparent: 'Real transparency',
  filterOpaque: 'Fully opaque',
  filterSuspected: 'Suspected background',
  filterProgress: 'In progress',
  filterError: 'Errors',
  sortLabel: 'Sort results',
  sortAdded: 'Added order',
  sortName: 'File name',
  sortTransparentDesc: 'Transparency: high to low',
  sortTransparentAsc: 'Transparency: low to high',
  selectAll: 'Select all visible results',
  selectedCount: '{count} selected',
  deleteSelected: 'Delete selected',
  reanalyzeSelected: 'Reanalyze selected',
  clearAll: 'Clear all',
  exportJson: 'Export JSON',
  exportCsv: 'Export CSV',
  exportNothing: 'Analyze at least one file before exporting a report.',
  tablePreview: 'Preview',
  tableFile: 'File',
  tableSize: 'Dimensions and size',
  tableAlpha: 'Real transparency',
  tableTransparent: 'Fully transparent',
  tableSemi: 'Semi-transparent',
  tablePadding: 'Padding',
  tableRisk: 'Suspected background',
  tableStatus: 'Status',
  tableActions: 'Actions',
  selectFile: 'Select {name}',
  openDetails: 'Open details for {name}',
  deleteFile: 'Delete {name}',
  reanalyzeFile: 'Reanalyze {name}',
  unknownDimensions: 'Waiting for dimensions',
  notAvailable: 'Not available',
  yes: 'Yes',
  no: 'No',
  none: 'None',
  pixels: 'px',
  paddingValues: 'T {top} R {right} B {bottom} L {left}',
  statusQueued: 'Queued',
  statusAnalyzing: 'Analyzing',
  statusReady: 'Analyzed',
  statusError: 'Error',
  statusTransparent: 'Real transparency',
  statusOpaque: 'Fully opaque',
  statusSuspected: 'Suspected',
  loadingFile: 'Analyzing {name}',
  loadingProgress: '{progress}% complete',
  emptyTitle: 'No PNG files in this batch',
  emptyBody: 'Add files above to inspect structure, alpha pixels, edges, and transparent padding.',
  emptyFilteredTitle: 'No results match these filters',
  emptyFilteredBody: 'Change the search text or status filter to see more files.',
  details: 'File details',
  noSelectionTitle: 'Select a result to inspect it',
  noSelectionBody: 'The preview, alpha statistics, findings, and trim controls will appear here.',
  preview: 'Preview',
  previewAlt: 'Preview of {name}',
  background: 'Preview background',
  backgroundWhite: 'White',
  backgroundBlack: 'Black',
  backgroundGray: 'Mid-gray',
  backgroundRed: 'Red',
  backgroundGreen: 'Green',
  backgroundBlue: 'Blue',
  backgroundChecker: 'Checkerboard',
  fit: 'Fit',
  actualSize: '100%',
  previewScale: 'Preview scale',
  zoomControls: 'Zoom controls',
  zoomOut: 'Zoom out',
  zoomIn: 'Zoom in',
  showBoundingBox: 'Bounding box',
  showMarginGuides: 'Margin guides',
  bboxUnavailable: 'No non-transparent content bounding box is available.',
  imageDimensions: 'Image dimensions',
  fileSize: 'File size',
  analyzedAt: 'Analyzed',
  duration: 'Duration',
  alphaStatistics: 'Alpha statistics',
  totalPixels: 'Total pixels',
  fullyTransparent: 'Fully transparent',
  semiTransparent: 'Semi-transparent',
  fullyOpaque: 'Fully opaque',
  minAlpha: 'Minimum alpha',
  maxAlpha: 'Maximum alpha',
  averageAlpha: 'Average alpha',
  edgeCoverage: 'Opaque edge coverage',
  transparentPadding: 'Transparent padding',
  pngStructure: 'PNG structure',
  bitDepth: 'Bit depth',
  colorType: 'Color type',
  trnsChunk: 'tRNS chunk',
  alphaSupport: 'Alpha support',
  findings: 'Findings',
  noFindings: 'No detection labels were produced.',
  findingRealTransparency: 'Real transparency',
  findingFullTransparencyPresent: 'Fully transparent pixels present',
  findingAlphaChannelUnused: 'Alpha channel unused',
  findingFullyOpaque: 'Fully opaque',
  findingSemiTransparentPixels: 'Semi-transparent pixels',
  findingEdgeContent: 'Content touches the edge',
  findingTransparentPadding: 'Transparent padding',
  findingSuspectedSolidBackground: 'Suspected solid background',
  findingSuspectedCheckerboard: 'Suspected baked checkerboard',
  findingCleanAsset: 'Clean asset',
  reasonSuspectedSolidBackground:
    'Opaque edge and corner samples are dominated by one low-variance color.',
  reasonSuspectedCheckerboard:
    'Two opaque edge colors repeat with horizontal and vertical checker-like periodicity.',
  confidence: '{value}% confidence',
  heuristicTitle: 'Heuristic result',
  heuristicDisclaimer:
    'Suspected background and checkerboard findings are heuristic and may be false positives.',
  semiDisclaimer:
    'Semi-transparent pixels are often valid for antialiasing, shadows, and soft edges.',
  trimTitle: 'Trim transparent padding',
  trimMargin: 'Keep margin',
  trimButton: 'Download trimmed PNG',
  trimWorking: 'Preparing PNG',
  trimReady: 'The original file is never modified.',
  trimNoPadding: 'This image has no removable transparent padding.',
  trimNoContent: 'A safe content bounding box could not be found.',
  trimPending: 'Wait for analysis to finish before trimming.',
  trimError: 'The trimmed PNG could not be created.',
  trimSuccess: 'Trimmed PNG created with {margin} px margin.',
  detectionGuide: 'Detection guide',
  guideRealTitle: 'Real transparency',
  guideRealBody: 'At least one decoded pixel has an alpha value below 255.',
  guideUnusedTitle: 'Unused alpha channel',
  guideUnusedBody: 'The PNG structure supports alpha, but every decoded pixel is fully opaque.',
  guideSolidTitle: 'Suspected solid background',
  guideSolidBody:
    'Opaque edges and corners share a dominant low-variance color. This is not proof of a baked background.',
  guideCheckerTitle: 'Suspected baked checkerboard',
  guideCheckerBody:
    'Repeated alternating colors were found near image edges. Patterned artwork can trigger this heuristic.',
  guidePaddingTitle: 'Transparent padding',
  guidePaddingBody:
    'The non-transparent content bounding box leaves removable transparent space around the asset.',
  localFooter: 'All analysis runs locally in your browser.',
  sourceFooter: 'Open source on GitHub',
  unexpectedError: 'An unexpected interface error occurred.',
} as const;

export type MessageKey = keyof typeof en;
